import type { RouteRecordRaw } from 'vue-router'

/**
 * 韶音 / MDM 专用路由（独立文件，不修改 routes.ts）
 * 通过 shokz-routes-register.ts 动态挂到 Customer 菜单组下
 */
export const shokzRoutes: RouteRecordRaw[] = [
  {
    path: 'mdm-customer-vendor',
    name: 'MdmCustomerVendor',
    component: () => import('@/views/customer/mdm-customer-vendor/index.vue'),
    meta: {
      title: 'MDM客商管理',
      requiresAuth: false,
      order: 10,
      permission: 'module:company-management:company-management'
    }
  },
  {
    path: 'mdm-enterprise-extension',
    name: 'MdmEnterpriseExtension',
    component: () => import('@/views/customer/mdm-enterprise-extension/index.vue'),
    meta: {
      title: '客商MDM属性',
      requiresAuth: false,
      hidden: true
    }
  }
]
